import { useQuery } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { ILogsPagingRes } from '@/shared/interfaces';
import { getUrlParamsFetch } from '@/shared';


const {get} = erpApi();

///* tanSctack query
export const useFetchLogs = ({
    page = 1,
    page_size = 10,
    modulo = '',
    accion = '',
    fecha_after='',
    fecha_before=''
  }: GetLogsParams) => {
    return useQuery({
      queryKey: ['logs', page, modulo,accion, fecha_after,fecha_before,page_size],
      queryFn: async () => {
        return getLogs({ page, modulo,accion,  fecha_after,fecha_before,page_size });
      },
    });
  };
  ///* axios
  export type GetLogsParams = {
    page?: number;
    page_size?: number;
    modulo?: string;
    accion?: string;
    fecha_after?: string | null;
    fecha_before?: string | null;
  };

  export const getLogs = async (params: GetLogsParams) => {
    const queryParams = getUrlParamsFetch({ ...params });

  return get<ILogsPagingRes>(
    `${urlBackend}api/v1/logs/?${queryParams}`,
    true
  );
  }